import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscProjectMatchingAnalyticIds = {
  teamsId: string;
  launchDateId: string;
};

export const useAscProjectMatchingAnalyticIds = (): AscProjectMatchingAnalyticIds => ({
  teamsId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_MATCHING_TEAMS),
  launchDateId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_MATCHING_LAUNCH_DATE),
});
